import { css } from '@emotion/core';
import { media, variables, tokens } from '@domain-group/fe-brary';
import * as designSystem from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors,
  spacing = tokens.spacing;
export var body = {
  name: "13yhk4n",
  styles: "display:flex;flex-direction:column;margin-top:17px;"
};
export var topSection = /*#__PURE__*/css("display:flex;flex-direction:column;", media('>=tablet', '<desktop'), "{margin:0 18px;}", media('>=tablet'), "{flex-direction:row;margin-top:0;}");
export var cardContainer = /*#__PURE__*/css("width:100%;", media('>=tablet'), "{width:324px;}");
export var right = /*#__PURE__*/css("display:block;vertical-align:top;flex-grow:1;margin:0 16px;", media('>=tablet'), "{margin:0 0 0 40px;}");
export var agencyInfoBox = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;", media('>=tablet'), "{flex-direction:row;align-items:flex-start;margin-bottom:24px;gap:", spacing.m, ";}");
export var agencyDetails = {
  name: "95numa",
  styles: "position:relative;top:-4px;"
};
export var agencyLogoBox = backgroundColour => /*#__PURE__*/css("height:42px;width:120px;background-color:", backgroundColour || 'transparent', ";margin-bottom:14px;", media('>=desktop'), "{margin-bottom:0;}");
export var agencyLogo = {
  name: "kihw5q",
  styles: "height:100%;width:100%;object-fit:contain;"
};
export var agencyName = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designSystem.designTokenFonts.subheading, ";");
export var agencyProfileLink = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designSystem.designTokenFonts.mini, ";text-decoration:underline;text-decoration-color:transparent;transition:text-decoration 0.1s linear;&:hover{text-decoration-color:", colors.neutral.heavy.default, ";}");
export var agentDescriptionHeading = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";font-family:", font.headingFontFamily, ";font-size:", font.h2FontSize, ";font-weight:600;margin-bottom:8px;");
export var videoColumn = /*#__PURE__*/css("margin-bottom:16px;", media('>=tablet'), "{margin-bottom:0;max-width:300px;}");
export var videoMobile = {
  name: "1rr2ff8",
  styles: "margin:25px 0;iframe{min-height:195px;}"
};
export var stats = /*#__PURE__*/css("margin:10px 18px 0;text-align:left;", media('>=desktop'), "{margin:20px 0 0;}");
export var statsInfo = /*#__PURE__*/css(designSystem.typography.bodySmall, " display:flex;color:", colors.neutral.base.default, ";text-align:left;vertical-align:top;margin-bottom:0;", media('>=tablet'), "{margin-bottom:16px;}");
export var infoImage = {
  name: "w9p5dx",
  styles: "position:relative;top:3px;height:fit-content;"
};
export var infoMessage = {
  name: "1sugwtq",
  styles: "padding-left:5px;"
};
export var descriptionBlock = {
  name: "ug8j3x",
  styles: "margin:16px 0 24px;"
};
export var collapsibleDescription = /*#__PURE__*/css("margin-top:24px;", media('>=tablet'), "{margin-top:12px;}");